import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Attachment } from '../models/project/attachment/attachment.interface';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class ProjectAttachmentService {
  private httpClient = inject(HttpClient);

  private attachmentsUrl = '';

  public setAttachmentsUrl(projectId: string) {
    this.attachmentsUrl = `${environment.apiUrl}/projects/${projectId}/attachments`;
  }

  public getProjectAttachments(
    parentId: string | null,
  ): Observable<Attachment[]> {
    if (parentId) {
      const params = new HttpParams().set('parentId', parentId);

      return this.httpClient.get<Attachment[]>(`${this.attachmentsUrl}`, {
        params,
      });
    } else {
      return this.httpClient.get<Attachment[]>(`${this.attachmentsUrl}`);
    }
  }

  public createAttachment(attachment: Attachment, correlationId?: string): Observable<Attachment> {
    return this.httpClient.post<Attachment>(this.attachmentsUrl, attachment, {
      headers: this.buildHeaders(correlationId),
    });
  }

  public deleteAttachment(id: string): Observable<null> {
    return this.httpClient.delete<null>(`${this.attachmentsUrl}/${id}`);
  }

  public renameAttachment(
    id: string,
    fileName: string,
  ): Observable<Attachment> {
    return this.httpClient.put<Attachment>(`${this.attachmentsUrl}/${id}`, {
      fileName,
    });
  }

  private buildHeaders(correlationId?: string): HttpHeaders | undefined {
    if (!correlationId) {
      return undefined;
    }

    return new HttpHeaders({
      'X-Correlation-Id': correlationId,
    });
  }
}
